import { getFieldType } from '../../utils';

export type PeekFieldType = 'array' | 'map';

export interface NavigationItem {
  value: unknown;
  fieldName: string;
  fieldType: PeekFieldType;
  path: string;
}

export function buildInitialItem(
  value: unknown,
  fieldName: string,
  fieldType: PeekFieldType
): NavigationItem {
  return { value, fieldName, fieldType, path: fieldName };
}

export function getDescriptionLabel(item: NavigationItem): string {
  const typeLabel = item.fieldType === 'array' ? 'Array' : 'Map';
  const count =
    item.fieldType === 'array'
      ? Array.isArray(item.value)
        ? item.value.length
        : 0
      : typeof item.value === 'object' && item.value !== null
        ? Object.keys(item.value).length
        : 0;
  const unit = item.fieldType === 'array' ? 'items' : 'fields';
  return `${typeLabel} - ${count} ${unit}`;
}

export function isNestedClickable(fieldType: string): boolean {
  return fieldType === 'array' || fieldType === 'object';
}

export interface ArrayItemEntry {
  index: number;
  value: unknown;
  path: string;
  isNestedClickable: boolean;
}

export function getArrayItemEntries(value: unknown, path: string): ArrayItemEntry[] {
  if (!Array.isArray(value)) return [];
  return value.map((item, index) => {
    const fieldType = getFieldType(item);
    return {
      index,
      value: item,
      path: `${path}[${index}]`,
      isNestedClickable: isNestedClickable(fieldType),
    };
  });
}

export interface MapFieldEntry {
  key: string;
  value: unknown;
  path: string;
  isNestedClickable: boolean;
}

export function getMapFieldEntries(value: unknown, path: string): MapFieldEntry[] {
  if (typeof value !== 'object' || value === null) return [];
  return Object.entries(value).map(([key, val]) => {
    const fieldType = getFieldType(val);
    return {
      key,
      value: val,
      path: `${path}.${key}`,
      isNestedClickable: isNestedClickable(fieldType),
    };
  });
}

export function isArrayView(item: NavigationItem): boolean {
  return item.fieldType === 'array' && Array.isArray(item.value);
}

export function isMapView(item: NavigationItem): boolean {
  return item.fieldType === 'map' && typeof item.value === 'object' && item.value !== null;
}
